import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Card, Button, Form, Badge, Accordion, Table, Modal } from 'react-bootstrap';
import { Portlet, PortletBody, PortletHeader } from '../../../partials/content/Portlet';
import { formatDate, formatDateTime, formatAmount } from '../../../../_metronic/utils/utils';
import UltimatePagination from '../../../partials/layout/PaginationComponent';
import { VendorSettlementsServices } from './VendorSettlements.services';
import { commonServices } from '../../../../app/commonServices/commonServices';
import FilterComponent from '../../../partials/layout/FilterComponent';
import * as constants from '../../../constants';

class VendorSettlements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      settlements: [],
      isFetching: false,
      page: 1,
      total: undefined,
      offset: 0,
      limit: 10,
      totalCount: 0,
      searchQuery: '',
      status: 'ALL',
      accordionData: null,
      prevId: null,

      // Filter settings state for FilterComponent
      state: ['OPEN'],
      propertyManagementStatus: ['YES'],
      // pmsSubscriptionType: [],                                        
      //requestedFilters: ['state', 'propertyManagementStatus'],
      requestedFilters: ['state'],
      maximumPaymentDueDate: undefined,
      maximumLatestNoteCreatedAt: undefined,
      propertyManagerId: undefined,
      cityIds: [],
      formattedCities: [],
      preSelectedCities: null,
      propertyManagers: [],

      // JSON Modal logic
      showPaymentDetailsModal: false,
      selectedPaymentJson: null,

      // Transfer Modal state
      showInitiateTransferModal: false,
      transferData: null,
      transferVendorChecked: true,
      transferAzuroChecked: false,
      transferMode: 'IMPS',
      isInitiatingTransfer: false,
      validationError: null, // Holds string for custom error popup
      successMessage: null // Holds string for custom success popup
    };
  }

  // Load backend settlements list and pre-populate dropdown lists on mount
  componentDidMount = async () => {
    await this.getData();
    await this.getCities();
    await this.getPropertyManagers();
  }

  // Fetch list of active Property Managers coordinates for select filter options dropdown
  getPropertyManagers = async () => {
    const data = {
      userRoleCodes: ['PROPERTY_MANAGER'],
    }
    const result = await commonServices.getUserListData(data);
    if (result && result.status === 200) {
      await this.setState({ propertyManagers: result.data.users })
    }
  }

  // Fetch system supported active cities list to configure selection filter options dropdown
  getCities = async () => {
    const { cityIds } = this.state;
    const data = {
      pmsOperationStatus: 'YES'
    }
    const result = await commonServices.getCities(data);
    if (result && result.status === 200) {
      const cities = result?.data?.cities;
      const formattedCities = commonServices.formatCities(cities);
      let preSelectedCities = null;
      if (this.state.cityIds?.length > 0) {
        preSelectedCities = commonServices.preSelectCities(formattedCities, cityIds);
      }
      await this.setState({ formattedCities });
      preSelectedCities && await this.setState({ preSelectedCities });
    }
  }

  // Retrieve paginated settlements data from API applying active filters
  getData = async () => {
    this.setState({ isFetching: true });
    const {
      offset,
      limit,
      searchQuery,
      status,
      state,
      propertyManagementStatus,
      pmsSubscriptionType,
      maximumPaymentDueDate,
      maximumLatestNoteCreatedAt,
      propertyManagerId,
      cityIds
    } = this.state;

    const data = {
      offset,
      limit,
      searchQuery: searchQuery || undefined,
      status: (status && status !== 'ALL') ? status : undefined,
      state: (state && state.length > 0) ? state : undefined,
      propertyManagementStatus: (propertyManagementStatus && propertyManagementStatus.length > 0) ? propertyManagementStatus : undefined,
      pmsSubscriptionType: (pmsSubscriptionType && pmsSubscriptionType.length > 0) ? pmsSubscriptionType : undefined,
      maximumPaymentDueDate: maximumPaymentDueDate || undefined,
      maximumLatestNoteCreatedAt: maximumLatestNoteCreatedAt || undefined,
      propertyManagerId: (propertyManagerId && propertyManagerId !== '0') ? propertyManagerId : undefined,
      cityIds: (cityIds && cityIds.length > 0) ? cityIds : undefined
    };

    const response = await VendorSettlementsServices.getVendorSettlementsData(data);
    if (response && response.status === 200) {
      const dataPayload = response.data;
      const vendorSettlements = dataPayload.data ? dataPayload.data.vendorSettlements : [];
      const totalCount = dataPayload.headers ? parseInt(dataPayload.headers['x-total-count'] || "0", 10) : 0;
      const totalPageNo = Math.ceil(totalCount / limit);
      this.setState({
        settlements: vendorSettlements,
        total: totalPageNo === 0 ? 1 : totalPageNo,
        totalCount
      });
    }
    this.setState({ isFetching: false });
  }

  // Handle accordion node click trigger to lazy load detailed transaction information for clicked item
  handleAccordionClick = async (id) => {
    const { prevId } = this.state;
    if (prevId !== id) {
      this.setState({ prevId: id, accordionData: null });
      const result = await VendorSettlementsServices.getVendorSettlementById(id);
      if (result && result.status === 200) {
        const paymentDetail = result.data.data ? result.data.data.vendorSettlement : result.data;
        this.setState({ accordionData: paymentDetail });
      }
    }
  }

  // Event handler callback for component pagination trigger
  onPageChange = async (page) => {
    const { limit } = this.state;
    const offset = (limit * (page - 1));
    await this.setState({ page, offset });
    await this.getData();
  }

  // Receives and applies updated filters from active state selections inside the FilterComponent
  handleFilterChildData = async (childData) => {
    if (childData) {
      // Map FilterComponent rent status parameter back to state
      if (childData.vendorSettlementStatus) {
        childData.status = childData.vendorSettlementStatus;
      } else {
        childData.status = 'ALL';
      }
      this.setState({ ...childData });
      await this.resetPage();
      await this.getData();
    }
  }

  // Reset pagination index to start position
  resetPage = async () => {
    await this.setState({
      page: 1,
      offset: 0
    });
  }

  // ---------------------------------------------------------
  // INITIATE TRANSFER LOGIC 
  // ---------------------------------------------------------

  // 1. Modal trigger function: Gets called when 'Initiate Transfer' button is clicked.
  // It receives the currently selected 'settlement' object and populates the modal's internal state.
  handleInitiateTransfer = (settlement) => {
    const { grandTotal } = this.getEstimateSummary(settlement.costEstimate?.costEstimateItems || []);
    const isCompletePaymentReceived = settlement.amount >= grandTotal - 1.0;

    // Limits calculation
    const availableCustomerBalance = Math.max(0, settlement.amount - (settlement.vendorPayoutDone || 0) - (settlement.azuroPayoutDone || 0));
    const maxVendorTransfer = Math.min(settlement.vendorPayoutPending || 0, availableCustomerBalance);
    const maxAzuroTransfer = Math.min(settlement.azuroPayoutPending || 0, availableCustomerBalance); // Note: azuro transfer is strictly blocked if not complete payment, but keeping math safe.

    this.setState({
      showInitiateTransferModal: true,   // Opens the Transfer popup
      transferData: settlement,          // Saves the currently selected settlement to show data in popup
      transferVendorChecked: (settlement.vendorPayoutPending > 0),       // Default to true if amount pending
      transferAzuroChecked: false,       // Platform margin payout is usually optional or separate, so unchecked
      transferMode: 'IMPS',              // Default transfer method
      isInitiatingTransfer: false,       // Reset the loading spinner
      vendorTransferAmount: maxVendorTransfer || 0,
      azuroTransferAmount: maxAzuroTransfer || 0,
      isCompletePaymentReceived,
      availableCustomerBalance,
      maxVendorTransfer,
      maxAzuroTransfer
    });
  }

  // 2. Submit form handler: Triggered when "Initiate Transfer" final confirmation button is clicked inside popup.
  submitTransfer = async () => {
    const { transferData, transferMode, transferVendorChecked, transferAzuroChecked, vendorTransferAmount, maxVendorTransfer, azuroTransferAmount, maxAzuroTransfer } = this.state;


    // Validation A: If Vendor is GST registered and no invoice is uploaded, block the transfer.
    if (transferVendorChecked && transferData.costEstimate?.gstType === 'GST_REG_VENDOR' && (!transferData.invoices || transferData.invoices.length === 0)) {
      this.setState({ validationError: "Vendor Full Payment is Not allowed without uploading invoice for GST registered Vendors." });
      return;
    }

    // Validation B: Ensure there is at least one customer payment to act as the source funds
    if (!transferData.customerPayments || transferData.customerPayments.length === 0) {
      this.setState({ validationError: "No incoming customer payment found associated with this settlement!" });
      return;
    }

    if (transferVendorChecked) {
      if (Number(vendorTransferAmount) <= 0) {
        this.setState({ validationError: "Vendor transfer amount must be greater than 0." });
        return;
      }
      if (Number(vendorTransferAmount) > maxVendorTransfer + 0.01) {
        this.setState({ validationError: `Vendor transfer amount cannot exceed available funds (₹${maxVendorTransfer}).` });
        return;
      }
    }

    if (transferAzuroChecked) {
      if (Number(azuroTransferAmount) <= 0) {
        this.setState({ validationError: "Azuro transfer amount must be greater than 0." });
        return;
      }
      if (Number(azuroTransferAmount) > maxAzuroTransfer + 0.01) {
        this.setState({ validationError: `Azuro transfer amount cannot exceed the maximum allowed limit based on available funds.` });
        return;
      }
    }

    // Pick the source payment ID (usually the original amount customer paid that triggered this object)
    const sourcePaymentId = transferData.customerPayments[0].id;

    // Auto-select the first bank account linked to the vendor. (Otherwise null, backend falls back to its default checking)
    const vendorBankAccountId = transferData.costEstimate?.vendorBankAccounts?.[0]?.id || null;

    try {
      // Set loading state to disable confirm button
      this.setState({ isInitiatingTransfer: true });

      // Prepare simple payload mapping according to backend transfer API requirements
      const payload = {
        sourcePaymentId,
        vendorBankAccountId,
        transferMode: transferMode.toLowerCase(),     // (imps, neft, rtgs)
        executeVendorTransfer: transferVendorChecked, // Tie checkbox boolean explicitly to backend logic
        vendorTransferAmount: transferVendorChecked ? Number(vendorTransferAmount) : 0,
        executeAzuroTransfer: transferAzuroChecked,
        azuroTransferAmount: transferAzuroChecked ? Number(azuroTransferAmount) : 0
      };

      // Execute the backend API
      const response = await VendorSettlementsServices.initiateTransfer(payload);
      if (response && response.status === 200) {
        this.setState({
          successMessage: "Transfer initiated successfully!",
          showInitiateTransferModal: false,
          isInitiatingTransfer: false
        });
        this.setState({ prevId: null }, () => {
          this.handleAccordionClick(transferData.id);
        });
        this.getData();
      } else {
        this.setState({ validationError: response?.data?.message || "Failed to initiate transfer.", isInitiatingTransfer: false });
      }
    } catch (err) {
      this.setState({ validationError: "Error initiating transfer: " + (err?.response?.data?.message || err.message), isInitiatingTransfer: false });
    }
  }



  // Calculate summary values for the line items
  getEstimateSummary = (costEstimateItems) => {
    let subtotal = 0;
    let totalGst = 0;
    (costEstimateItems || []).forEach(item => {
      const qty = Number(item.qty || 1);
      const actualCost = Number(item.amount || 0);
      const margin = Number(item.margin || 0);
      const gstPct = Number(item.gstPercentage || 18);
      const customerPrice = actualCost + margin;
      const tax = qty * customerPrice * (gstPct / 100);

      subtotal += qty * customerPrice;
      totalGst += tax;
    });
    return { subtotal, totalGst, grandTotal: subtotal + totalGst };
  }

  // Render detailed view for individual settlement
  renderAccordionBody = (settlement) => {
    const costEstimate = settlement.costEstimate || {};
    const items = costEstimate.costEstimateItems || [];
    const customerTotalItems = items.length;
    const { subtotal, totalGst, grandTotal } = this.getEstimateSummary(items);

    // Default formatted address logic
    const shortCustomerName = settlement.customerPayments?.[0]?.user?.fullName || costEstimate.customerName;
    const shortCustomerAddress = costEstimate.billingAddress;

    const pendingTotal = settlement.vendorPayoutPending + settlement.azuroPayoutPending;

    const invoices = settlement.invoices || [];
    let invoicesTotalValue = 0;
    invoices.forEach(inv => invoicesTotalValue += Number(inv.totalAmount || 0));

    return (
      <Card.Body className="p-4" style={{ backgroundColor: '#fcfdfe', borderTop: '2px solid #eef0f8' }}>
        {/* Estimate Title Block */}
        <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom border-light">
          <div>
            <h5 className="font-weight-bold mb-1 text-dark" style={{ letterSpacing: '-0.3px' }}>
              Estimate #{costEstimate.id || '-'} <span className="text-muted font-weight-normal mx-2">|</span> <span className="text-muted" style={{ fontSize: '1.05rem' }}>Vendor: {costEstimate.vendorName || '-'}</span>
            </h5>
            <div className="text-muted small">Line items breakdown, payment history &amp; multi-vendor tax invoice repository</div>
          </div>
          <div>
            <Badge className="font-weight-bold text-dark px-3 py-2 border shadow-sm" style={{ backgroundColor: '#fff3cd', borderColor: '#ffeeba', fontSize: '0.85rem' }}>
              Approved <i className="fa fa-caret-down ml-2 text-muted"></i>
            </Badge>
          </div>
        </div>

        {/* 3 Summary Cards */}
        <Row className="mb-4">
          <Col md={4}>
            <Card className="h-100 shadow-sm border border-light rounded-lg">
              <Card.Body className="p-3">
                <div className="text-muted font-weight-bold small text-uppercase mb-3" style={{ letterSpacing: '0.5px' }}>Customer</div>
                <h6 className="font-weight-bolder mb-1 text-truncate text-dark text-uppercase">{shortCustomerName}</h6>
                <div className="small text-muted mb-2 text-truncate">{shortCustomerAddress}</div>
                <div className="small text-muted">GSTIN: {costEstimate.gstin || 'Unregistered'}</div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 shadow-sm border border-light rounded-lg">
              <Card.Body className="p-3">
                <div className="text-muted font-weight-bold small text-uppercase mb-3" style={{ letterSpacing: '0.5px' }}>Service</div>
                <h6 className="font-weight-bolder mb-1 text-dark">
                  {costEstimate.serviceType === 'VENDOR_WITH_AZURO_MARGIN'
                    ? 'Subcontractor'
                    : costEstimate.serviceType === 'VENDOR_ONLY'
                      ? 'External Vendor'
                      : costEstimate.serviceType === 'AZURO'
                        ? 'AZURO MST'
                        : costEstimate.serviceType}
                </h6>
                <div className="small text-muted mb-2">GST Status: <strong className="text-dark">{costEstimate.gstType === 'GST_REG_VENDOR' ? 'GST Registered' : 'Not Registered'}</strong></div>
                <div className="small text-muted">Payment Collection Type: Full Collection</div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 shadow-sm border border-light rounded-lg">
              <Card.Body className="p-3">
                <div className="text-muted font-weight-bold small text-uppercase mb-3" style={{ letterSpacing: '0.5px' }}>Quick Summary</div>
                <h6 className="font-weight-bolder mb-1 text-dark">Total Items: <span className="text-primary">{customerTotalItems}</span></h6>
                <div className="small font-weight-bold mb-2" style={{ color: '#0eb580' }}>Advance Received: {formatAmount(settlement.amount)}</div>
                <div className="small text-muted">Balance Due: {formatAmount(Math.max(0, grandTotal - settlement.amount))}</div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Line Items Table */}
        <Card className="shadow-sm border border-light rounded-lg mb-4 overflow-hidden">
          <Table responsive className="mb-0 text-dark">
            <thead className="bg-light text-muted font-weight-bold" style={{ backgroundColor: '#f4f6f9' }}>
              <tr>
                <th className="border-0 py-3 pl-4" style={{ color: '#495057' }}>ITEM NAME</th>
                <th className="border-0 py-3 text-center" style={{ color: '#495057' }}>QTY</th>
                <th className="border-0 py-3 text-right" style={{ color: '#495057' }}>ACTUAL COST (₹)</th>
                <th className="border-0 py-3 text-right" style={{ color: '#495057' }}>AZURO MARGIN (₹)</th>
                <th className="border-0 py-3 text-right" style={{ color: '#495057' }}>CUSTOMER PRICE (₹)</th>
                <th className="border-0 py-3 text-center" style={{ color: '#495057' }}>GST RATE</th>
                <th className="border-0 py-3 pr-4 text-right" style={{ color: '#495057' }}>ITEM TOTAL (₹)</th>
              </tr>
            </thead>
            <tbody>
              {items.sort((a, b) => a.id - b.id).map((item, idx) => {

                const qty = Number(item.qty || 1);
                const actualCost = Number(item.amount || 0);
                const margin = Number(item.margin || 0);
                const gstPct = Number(item.gstPercentage || 18);
                const customerPrice = actualCost + margin;
                const tax = qty * customerPrice * (gstPct / 100);
                const itemTotal = (qty * customerPrice) + tax;
                return (
                  <tr key={idx} className="border-bottom border-light">
                    <td className="py-4 pl-4 font-weight-bold text-truncate" style={{ maxWidth: '250px' }}>{item.itemName || item.title || item.name || 'Service Item'}</td>
                    <td className="py-4 text-center font-weight-bold">{qty}</td>
                    <td className="py-4 text-right">{formatAmount(actualCost)}</td>
                    <td className="py-4 text-right font-weight-bold" style={{ color: '#5c45e5' }}>+{formatAmount(margin)}</td>
                    <td className="py-4 text-right font-weight-bold">{formatAmount(customerPrice)}</td>
                    <td className="py-4 text-center">{gstPct}%</td>
                    <td className="py-4 pr-4 text-right font-weight-bold">{formatAmount(itemTotal)}</td>
                  </tr>
                );
              })}
              {/* Subtotal Footer */}
              <tr style={{ backgroundColor: '#fcfdfe' }}>
                <td colSpan="4" className="border-0 pt-4 pb-3 pl-4">
                  <div className="small text-muted font-weight-bold text-uppercase mb-2" style={{ letterSpacing: '0.5px' }}>Remarks / Notes</div>
                  <div className="small text-muted font-italic">"Estimate approved by the customer. Work completed."</div>
                </td>
                <td colSpan="3" className="border-0 text-right pt-4 pb-4 pr-4">
                  <div className="mb-2 text-muted small">Subtotal: <strong className="text-dark ml-3">{formatAmount(subtotal)}</strong></div>
                  <div className="mb-2 text-muted small border-bottom border-light pb-3">Total GST Component: <strong className="text-dark ml-3">{formatAmount(totalGst)}</strong></div>
                  <div className="mb-1 mt-3 small font-weight-bold" style={{ color: '#0eb580' }}>Advance Payment Received: <span className="ml-3">-{formatAmount(settlement.amount)}</span></div>
                  <h5 className="mt-3 font-weight-bolder text-dark">Remaining Balance: {formatAmount(Math.max(0, grandTotal - settlement.amount))}</h5>
                </td>
              </tr>
            </tbody>
          </Table>
        </Card>

        {/* Payments Section */}
        <Card className="shadow-sm border-0 rounded-lg mb-4">
          <Card.Header className="bg-white border-bottom-0 pt-4 pb-2">
            <h5 className="font-weight-bold mb-0" style={{ color: "#545579" }}>
              Payment Journey
            </h5>
          </Card.Header>

          <Card.Body>

            {[...(settlement.customerPayments || []).map(p => ({
              ...p,
              type: "CREDIT"
            })),
            ...(settlement.resultantPayments || []).map(p => ({
              ...p,
              type: "DEBIT"
            }))]
              .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
              .map((payment, index, arr) => {

                const isCredit = payment.type === "CREDIT";

                return (

                  <div
                    key={`${payment.type}-${payment.id}`}
                    className="d-flex"
                  >

                    {/* Timeline */}
                    <div
                      className="d-flex flex-column align-items-center"
                      style={{
                        width: 45
                      }}
                    >

                      <div
                        style={{
                          width: 32,
                          height: 32,
                          borderRadius: "50%",
                          background: isCredit ? "#e8f8ef" : "#fdecec",
                          color: isCredit ? "#28a745" : "#dc3545",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "bold",
                          fontSize: 14,
                          border: `2px solid ${isCredit ? "#28a745" : "#dc3545"}`
                        }}
                      >
                        {isCredit ? "+" : "₹"}
                      </div>


                      {index !== arr.length - 1 && (
                        <div
                          style={{
                            width: 2,
                            flex: 1,
                            background: "#e5e7eb",
                            minHeight: 80
                          }}
                        />
                      )}

                    </div>


                    {/* Card */}
                    <div
                      className="mb-4 flex-grow-1"
                      style={{
                        background: "#fff",
                        borderRadius: 12,
                        border: "1px solid #eee",
                        boxShadow: "0 3px 12px rgba(0,0,0,0.06)"
                      }}
                    >

                      <div className="p-3">


                        <div className="d-flex justify-content-between">

                          <div>

                            <div
                              className="font-weight-bold"
                              style={{
                                color: "#545579",
                                fontSize: 15
                              }}
                            >
                              {isCredit
                                ? "Payment Received"
                                : "Payment Transfer Completed"}
                            </div>


                            <div
                              className="mt-1"
                              style={{
                                fontSize: 22,
                                fontWeight: 700,
                                color: isCredit
                                  ? "#28a745"
                                  : "#dc3545"
                              }}
                            >
                              {isCredit ? "+" : "-"}
                              {formatAmount(payment.amount)}
                            </div>


                          </div>

                          <a
                            href="javascript:void(0)"
                            className="small font-weight-bold"
                            style={{
                              color: "#5c45e5"
                            }}
                            onClick={() =>
                              this.setState({
                                showPaymentDetailsModal: true,
                                selectedPaymentJson: payment
                              })
                            }
                          >
                            View Details
                          </a>
                        </div>

                        <div
                          className="mt-3 p-2 rounded"
                          style={{
                            background: "#f8f9fa"
                          }}
                        >
                          <div className="small mb-1">
                            <strong>
                              {isCredit ? "Received From:" : "Paid To:"}
                            </strong>{" "}
                            {isCredit
                              ? "Customer"
                              : payment.user
                                ? payment.user.fullName
                                : "Vendor / Azuro"}
                          </div>

                          <div className="small text-muted">
                            Reference: {payment.reference || "-"}
                          </div>
                          <div className="small text-muted">
                            Mode: {payment.mode || "ONLINE"}
                          </div>
                          <div className="small text-muted">
                            {payment.datetime
                              ? formatDateTime(payment.datetime)
                              : "-"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}


            <div
              className="mt-2 p-3 rounded d-flex justify-content-between align-items-center"
              style={{
                background: "#f4f6ff",
                border: "1px solid #e3e6ff"
              }}
            >

              <strong style={{ color: "#545579" }}>
                Pending Transfer
              </strong>

              <div className="d-flex align-items-center">
                <h5 className="mb-0 font-weight-bold text-primary mr-4">
                  {formatAmount(pendingTotal)}
                </h5>
                {pendingTotal > 0 && (
                  <Button
                    variant="primary"
                    className="text-nowrap font-weight-bold align-self-center shadow-sm"
                    style={{ backgroundColor: '#4432c9', borderColor: '#4432c9' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.handleInitiateTransfer(settlement);
                    }}
                  >
                    Initiate Transfer <i className="flaticon-paper-plane ml-2" style={{ fontSize: "0.9rem" }}></i>
                  </Button>
                )}
              </div>

            </div>


          </Card.Body>
        </Card>

        {/* Invoices Section (Tax Vault) */}
        <Card className="shadow-sm border border-light rounded-lg">
          <Card.Header className="bg-white border-bottom pt-4 pb-3 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <i className="flaticon2-file mr-2" style={{ color: '#5c45e5', fontSize: '1.2rem' }}></i>
              <h6 className="font-weight-bolder text-uppercase text-dark mb-0 mr-3" style={{ letterSpacing: '0.5px' }}>Collected Vendor Invoices <span className="text-muted">(Tax Vault)</span></h6>
              <Badge variant="light" className="font-weight-bold px-3 py-1 rounded-pill" style={{ backgroundColor: '#eef0f8', color: '#5c45e5' }}>{invoices.length} FILES</Badge>
            </div>
            <div>
              <input
                type="file"
                id={`upload-invoice-sync-${settlement.id}`}
                style={{ display: 'none' }}
                accept="application/pdf,image/*"
                onChange={async (e) => {
                  if (e.target.files && e.target.files[0]) {
                    const file = e.target.files[0];
                    const houseId = settlement.costEstimate?.serviceRequest?.house?.id || settlement.costEstimate?.house?.id || settlement.houseId || settlement.house?.id;

                    if (!houseId) {
                      alert("Property/House is required to attach an invoice.");
                      e.target.value = null;
                      return;
                    }

                    try {
                      const fileFormData = new FormData();
                      fileFormData.append('files', file);
                      fileFormData.append('files[0][identifier]', 'vendor-invoice-doc');

                      const uploadRes = await VendorSettlementsServices.uploadFileDirect(fileFormData);

                      let fileUrl = "";
                      if (uploadRes && uploadRes.data && uploadRes.data.length > 0) {
                        fileUrl = uploadRes.data[0].url;
                      }

                      if (!fileUrl) {
                        alert("Failed to upload the file to the cloud.");
                      } else {
                        const payload = {
                          invoiceNumber: `INV-${Date.now().toString().slice(-6)}`,
                          invoiceDate: new Date().toISOString(),
                          houseId: houseId,
                          title: `Vendor Tax Invoice for SR#${settlement.costEstimate?.serviceRequest?.id || 'Misc'}`,
                          invoiceItems: [{ name: "Vendor Service Amount", amount: settlement.amount || 0 }],
                          costEstimateId: settlement.costEstimate?.id,
                          fileUrl: fileUrl
                        };

                        const invoiceRes = await commonServices.createInvoice(payload);
                        if (invoiceRes && (invoiceRes.status === 200 || invoiceRes.status === 201)) {
                          alert("Vendor Invoice successfully uploaded and synced to Tax Vault!");
                          // Refresh list
                          this.getData();
                        } else {
                          alert("Failed to process invoice record via server.");
                        }
                      }
                    } catch (error) {
                      alert("Error uploading file: " + error.message);
                    } finally {
                      e.target.value = null; // reset
                    }
                  }
                }}
              />
              <Button
                variant="primary"
                className="font-weight-bold px-4 rounded-pill shadow-sm py-2"
                style={{ backgroundColor: '#4432c9', borderColor: '#4432c9' }}
                onClick={() => document.getElementById(`upload-invoice-sync-${settlement.id}`).click()}
              >
                Upload Vendor Invoice
              </Button>
            </div>
          </Card.Header>
          <Card.Body className="p-4" style={{ backgroundColor: '#fcfdfe' }}>
            <p className="text-muted small mb-4">Attach and verify multiple GST tax invoices collected from vendor</p>
            {invoices.length === 0 && (
              <div className="text-center p-4 border border-light border-dashed rounded bg-white">
                <div className="text-muted">No tax invoices attached yet for this estimate.</div>
              </div>
            )}
            {invoices.map((inv, i) => (
              <div key={inv.id || i} className="d-flex justify-content-between align-items-center bg-white p-3 rounded-lg border border-light shadow-sm mb-3 position-relative">
                <div className="d-flex align-items-center">
                  <div className="mr-3">
                    <div className="d-flex justify-content-center align-items-center rounded bg-danger" style={{ width: '45px', height: '45px' }}>
                      <span className="text-white font-weight-bold small">PDF</span>
                    </div>
                  </div>
                  <div>
                    <div className="d-flex align-items-center mb-1">
                      <span className="font-weight-bold text-dark mr-3" style={{ fontSize: '1.05rem', letterSpacing: '-0.2px' }}>{inv.invoiceNumber || `INV-TEMP-${inv.id}`}</span>
                      <span className="text-muted small mr-3 bg-light px-2 py-1 rounded text-truncate" style={{ fontSize: '0.75rem', maxWidth: '180px' }}>
                        {inv.fileUrl ? inv.fileUrl.split('/').pop() : inv.title || 'Attached_Invoice.pdf'}
                      </span>
                      {inv.validityStatus === 'VALID' ? (
                        <Badge className="px-2 py-1 shadow-sm" style={{ backgroundColor: '#f0f5f1', color: '#1a7541', border: '1px solid #d6e8dd' }}>VERIFIED</Badge>
                      ) : (
                        <Badge className="px-2 py-1 shadow-sm" style={{ backgroundColor: '#eaf0ff', color: '#3a72b8', border: '1px solid #c8d9fb' }}>UNRECONCILED</Badge>
                      )}
                    </div>
                    <div className="text-muted mt-2" style={{ fontSize: '0.75rem' }}>
                      Date: <strong className="text-dark">{inv.invoiceDate ? formatDate(inv.invoiceDate) : formatDateTime(inv.createdAt)}</strong> &bull; Uploaded by {inv.creator?.fullName || 'System User'}
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-end text-right">
                  <div className="mr-4 border-right pr-4">
                    <div className="text-muted mb-1 font-weight-bold" style={{ fontSize: '0.7rem' }}>Status: {inv.status || 'DRAFT'}</div>
                    <h6 className="font-weight-bolder text-dark mb-0">Total: {formatAmount(inv.totalAmount || 0)}</h6>
                  </div>
                  {/* <Button
                    variant="light"
                    size="sm"
                    className="font-weight-bold px-3 mr-2 bg-light border-light shadow-none"
                    onClick={() => inv.fileUrl ? window.open(inv.fileUrl, '_blank') : alert('File URL not available')}
                  >
                    View PDF
                  </Button> */}

                  <Button
                    variant="light"
                    size="sm"
                    className="font-weight-bold px-3 mr-2 bg-light border-light shadow-none"
                    onClick={() => this.handleInvoiceViewFile(inv.fileUrl)}
                  >
                    View PDF
                  </Button>

                  <Button variant="link" size="sm" className="text-muted p-2 shadow-none" title="Delete Invoice"><i className="flaticon-delete"></i></Button>
                </div>
              </div>
            ))}

            <div className="d-flex justify-content-between align-items-center border-top border-light pt-4 mt-3">
              <div className="small text-muted font-weight-bold text-uppercase" style={{ letterSpacing: '0.5px' }}>Total Invoices Value Attached:</div>
              <h5 className="font-weight-bolder text-dark mb-0">{formatAmount(invoicesTotalValue)}</h5>
            </div>
          </Card.Body>
        </Card>
      </Card.Body>
    );
  }

  handleInvoiceViewFile = async (fileUrl) => {
    if (!fileUrl) {
      alert("File URL not available");
      return;
    }

    try {
      const response = await VendorSettlementsServices.getPreSignedFileURL({
        unsignedFileUrl: fileUrl
      });

      if (response?.data?.status === 1 && response?.data?.filePath) {
        window.open(response.data.filePath, "_blank");
      } else {
        alert("Unable to generate file URL");
      }
    } catch (error) {
      console.error("Error while opening file:", error);
      alert("Unable to open file");
    }
  };

  render() {
    const { settlements, page, total, totalCount, isFetching, requestedFilters, state, formattedCities, preSelectedCities, maximumPaymentDueDate, maximumLatestNoteCreatedAt, propertyManagers, propertyManagerId, propertyManagementStatus, pmsSubscriptionType } = this.state;
    let showPagination = false;
    if (total) { showPagination = total !== 0 && total !== 1; }

    return (
      <Container fluid>
        <Portlet fluidHeight={true}>
          {/* Main Card Header displaying total matching bills count */}
          <PortletHeader title={`Vendor Payment Bills (${totalCount || 0})`} />
          <PortletBody>
            {/* Unified Custom Filters Panel */}
            <FilterComponent
              requestedFilters={requestedFilters}
              state={state}
              formattedCities={formattedCities}
              preSelectedCities={preSelectedCities}
              maximumPaymentDueDate={maximumPaymentDueDate}
              maximumLatestNoteCreatedAt={maximumLatestNoteCreatedAt}
              propertyManagers={propertyManagers}
              propertyManagerId={propertyManagerId}
              propertyManagementStatus={propertyManagementStatus}
              recordsPerPage={constants.RECORDS_PER_PAGE}
              // Updated status options for Vendor Settlements
              //  vendorSettlementStatusData={['PENDING TRANSFER', 'PROCESSING TRANSFER', 'PARTIALLY TRANSFERRED', 'TRANSFERRED']}
              selectedRecordValue={this.state.limit}
              selectedVendorSettlementStatus={this.state.status}
              //pmsSubscriptionType={pmsSubscriptionType}
              filterParentCallback={this.handleFilterChildData}
            />

            {/* List Accordion / Spinner Logic */}
            {isFetching ? (
              <div className="py-5 text-center text-muted">
                <p>{constants.LOADING_DATA}</p>
              </div>
            ) : (
              <div className="mt-3">
                <Accordion defaultActiveKey="0">
                  {settlements && settlements.length > 0 && (
                    <Card key="header-vs" style={{ backgroundColor: '#f8f9fa', border: 'none' }}>
                      <Card.Header style={{ backgroundColor: 'transparent', border: 'none', padding: '10px 20px' }}>
                        <Row className="align-items-center" style={{ fontStyle: 'italic', color: '#555', fontSize: '13px' }}>
                          <Col xs={1}><strong>SR No</strong></Col>
                          <Col xs={3}><strong>Property Details</strong></Col>
                          <Col xs={2}><strong>Vendor</strong></Col>
                          <Col xs={2}><strong>Service &amp; Work Type</strong></Col>
                          <Col xs={4}><strong>Amount &amp; Date</strong></Col>
                        </Row>
                      </Card.Header>
                    </Card>
                  )}
                  {settlements && settlements.length === 0 && (
                    <p className="p-4 text-center text-muted font-italic">{constants.ZERO_DATA}</p>
                  )}

                  {/* List Rows */}
                  {settlements && settlements.map(settlement => (
                    <Card
                      key={settlement.id}
                      className="mb-2"
                      style={{
                        border: '1px solid #e9ecef',
                        borderRadius: '8px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
                      }}
                    >
                      {/* Accordion Row Clickable Header */}
                      <Accordion.Toggle
                        as={Card.Header}
                        eventKey={settlement.id}
                        onClick={() => this.handleAccordionClick(settlement.id)}
                        style={{
                          cursor: 'pointer',
                          backgroundColor: '#fff',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '12px 20px',
                          transition: 'background-color 0.2s'
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f0fff4'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#fff'; }}
                      >
                        <Row className="align-items-center w-100 m-0">
                          {/* 1. Payment/Estimate IDs Column */}
                          <Col xs={1}>
                            {settlement.costEstimate?.serviceRequest?.id ? (
                              <div style={{ fontWeight: 500, fontSize: '13px' }}>
                                SR<strong className="text-dark">#{settlement.costEstimate.serviceRequest.id}</strong>
                              </div>
                            ) : (
                              <div className="small text-muted">-</div>
                            )}
                          </Col>

                          {/* 2. Property Details Column */}
                          <Col xs={3} className="d-flex align-items-center">
                            <span className="pr-3">
                              <span
                                className="rounded-circle d-inline-block mr-2"
                                style={{
                                  width: '10px',
                                  height: '10px',
                                  backgroundColor: '#28a745'
                                }}
                              />
                            </span>
                            <div>
                              <span className="font-weight-bold text-dark">{settlement.formattedHouseName || settlement.costEstimate?.billingAddress || 'No Property Info'}</span>
                              <div className="small text-muted mt-1">
                                {(settlement.customerPayments?.[0]?.user?.fullName || settlement.costEstimate?.customerName)
                                  ? <span className="font-italic">Customer: {settlement.customerPayments?.[0]?.user?.fullName || settlement.costEstimate?.customerName}</span>
                                  : (settlement.propertyManager ? `PM: ${settlement.propertyManager.fullName}` : 'PM: Not Assigned')
                                }
                              </div>
                              <div className="small text-muted" style={{ fontSize: '0.75rem', fontStyle: 'italic' }}>
                                Created: {settlement.createdAt ? formatDateTime(settlement.createdAt) : settlement.datetime ? formatDateTime(settlement.datetime) : 'N/A'}
                              </div>
                            </div>
                          </Col>


                          {/* 3. Vendor Details Column */}
                          <Col xs={2}>
                            <div className="font-weight-bold text-dark">{settlement.costEstimate?.vendorName || '-'}</div>
                            <div className="mt-1">
                              {settlement.costEstimate?.gstType === 'GST_REG_VENDOR' ? (
                                <Badge variant="success" className="text-uppercase small">GST Registered</Badge>
                              ) : (
                                <Badge variant="warning" className="text-uppercase small" style={{ backgroundColor: '#fff3cd', color: '#856404', border: '1px solid #ffeeba' }}>Non-Registered</Badge>
                              )}
                              {settlement.costEstimate?.gstin && (
                                <div className="small text-muted mt-1" style={{ fontSize: '0.72rem' }}>
                                  GSTIN: {settlement.costEstimate.gstin}
                                </div>
                              )}
                            </div>
                          </Col>

                          {/* 4. Service Type Column */}
                          {/* <Col xs={2}>
                            <div className="font-weight-bold text-dark text-truncate" title={settlement.costEstimate?.serviceName || '-'}>
                              {settlement.costEstimate?.serviceName || '-'}
                            </div>
                            <div className="small text-muted mt-1">
                              {settlement.costEstimate?.serviceType === 'VENDOR_WITH_AZURO_MARGIN' ? 'Subcontractor' : 'External Vendor'}
                            </div>
                            <div className="mt-1">
                              {settlement.costEstimate?.serviceType === 'VENDOR_WITH_AZURO_MARGIN' ? (
                                <Badge variant="primary" className="small">VENDOR + AZURO</Badge>
                              ) : (
                                <Badge variant="secondary" className="small">VENDOR ONLY</Badge>
                              )}
                            </div>

                          </Col>
                           */}
                          <Col xs={2}>
                            <div className="font-weight-bold text-dark text-truncate" title={settlement.costEstimate?.serviceName || '-'}>
                              {settlement.costEstimate?.serviceName || '-'}
                            </div>
                            <div className="small text-muted mt-1">
                              {/* {settlement.costEstimate?.serviceType}
                               */}
                              <Badge
                                variant="warning"
                                className="text-uppercase small"
                                style={{ backgroundColor: '#e0f4ff', color: '#0077b6', border: '1px solid #90caf9' }}
                              >
                                {settlement.costEstimate?.serviceType === 'VENDOR_WITH_AZURO_MARGIN'
                                  ? 'Subcontractor'
                                  : settlement.costEstimate?.serviceType === 'VENDOR_ONLY'
                                    ? 'External Vendor'
                                    : settlement.costEstimate?.serviceType === 'AZURO'
                                      ? 'AZURO MST'
                                      : settlement.costEstimate?.serviceType}
                              </Badge>
                            </div>


                          </Col>

                          {/* 5. Amount Details Column */}
                          <Col xs={4}>
                            <div className="font-weight-bold text-dark" style={{ fontSize: '1.05rem' }}>
                              {formatAmount(settlement.amount)}
                            </div>
                            <div className="small text-muted mt-1">
                              {settlement.datetime ? formatDateTime(settlement.datetime) : 'N/A'}
                            </div>
                            <span className="text-success small font-weight-bold mt-1 d-block">
                              Received Payment ✓
                            </span>
                          </Col>
                        </Row>
                      </Accordion.Toggle>
                      {/* Accordion Detailed Substructure */}
                      <Accordion.Collapse eventKey={settlement.id}>
                        {this.renderAccordionBody(settlement)}
                      </Accordion.Collapse>
                    </Card>
                  ))}
                </Accordion>

                {/* Ultimate Pagination Component */}
                {showPagination && (
                  <div className="d-flex justify-content-end mt-4">
                    <UltimatePagination
                      currentPage={page}
                      totalPages={total}
                      onChange={this.onPageChange}
                    />
                  </div>
                )}
              </div>
            )}
          </PortletBody>
        </Portlet>

        {/* JSON Display Modal */}
        <Modal
          show={this.state.showPaymentDetailsModal}
          onHide={() => this.setState({ showPaymentDetailsModal: false, selectedPaymentJson: null })}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title className="font-weight-bold text-dark">
              Payment Breakdown Details <span className="text-muted small ml-2">(ID: {this.state.selectedPaymentJson?.id})</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-light p-4">
            <div className="bg-white p-3 border rounded shadow-sm overflow-auto" style={{ maxHeight: '60vh', fontSize: '0.85rem' }}>
              <pre className="mb-0 text-dark">
                {this.state.selectedPaymentJson && JSON.stringify(this.state.selectedPaymentJson, null, 2)}
              </pre>
            </div>
          </Modal.Body>
        </Modal>

        {/* Transfer Initiation Full-Page Popup */}
        {this.state.transferData && (
          <Modal show={this.state.showInitiateTransferModal} size="xl" onHide={() => this.setState({ showInitiateTransferModal: false })} backdrop="static">
            <Modal.Header closeButton className="border-bottom pb-4" style={{ backgroundColor: '#fcfcfe' }}>
              <div className="w-100">
                <h4 className="font-weight-bolder text-dark mb-1">Initiate transfer</h4>
                <div className="text-muted small">Review beneficiary account, payables and confirm bank transfer.</div>

                <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top" style={{ margin: '-1rem -1rem 0 -1rem', padding: '10px 1rem' }}>
                  <div className="small text-muted d-flex align-items-center">
                    <i className="flaticon2-time mr-2"></i>
                    Last updated {this.state.transferData.datetime ? formatDateTime(this.state.transferData.datetime) : 'N/A'} by {(this.state.transferData.propertyManager || {}).fullName || 'System'}.
                  </div>
                  <div>
                    <Badge variant="light" className="px-2 py-1 mr-2 text-muted border border-light" style={{ backgroundColor: '#f4f5f8' }}>SR#{this.state.transferData.costEstimate?.serviceRequest?.id || 'N/A'}</Badge>
                    <Badge variant="light" className="px-2 py-1 text-primary border" style={{ backgroundColor: '#f4f1fe', borderColor: '#e9e6fb !important' }}>{this.state.transferData.reference}</Badge>
                  </div>
                </div>
              </div>
            </Modal.Header>

            <Modal.Body className="bg-light p-4" style={{ backgroundColor: '#f8f9fa' }}>
              <Row className="mb-3">
                <Col md={6}>
                  {/* 1. Select bank account */}
                  <div className="card shadow-sm border-0 rounded-lg h-100">
                    <div className="card-header bg-white border-bottom-0 pb-0 pt-3">
                      <h6 className="font-weight-bolder text-dark">1. Vendor bank account</h6>
                    </div>
                    <div className="card-body pt-2 pb-3">
                      <div className="p-3 position-relative rounded mb-2" style={{ backgroundColor: '#f9f8ff', border: '1px solid #5c45e5' }}>
                        <Badge variant="warning" className="position-absolute" style={{ top: '10px', right: '10px', fontWeight: 'bold' }}>PRIMARY</Badge>
                        <div className="font-weight-bolder text-dark mb-1">A/c No: {this.state.transferData.costEstimate?.vendorBankAccounts?.[0]?.accountNumber || 'Not Configured'}</div>
                        <div className="small text-muted mb-1">Bank: {this.state.transferData.costEstimate?.vendorBankAccounts?.[0]?.bankName || '-'} ({this.state.transferData.costEstimate?.vendorBankAccounts?.[0]?.ifsc || '-'})</div>
                        <div className="small text-muted">Beneficiary ID: {this.state.transferData.costEstimate?.vendorBankAccounts?.[0]?.cashfreeBeneficiaryId || 'Not synced'}</div>
                      </div>
                      <div className="small text-muted px-2"> Ensure account is added and a settlement account is created.</div>
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  {/* 2. Payment summary */}
                  <div className="card shadow-sm border-0 rounded-lg h-100">
                    <div className="card-header bg-white border-bottom-0 pb-0 pt-3">
                      <h6 className="font-weight-bolder text-dark">2. Payment summary</h6>
                    </div>
                    <div className="card-body pt-2 pb-3">
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted font-weight-bold">Amount pending to be transferred:</span>
                        <span className="font-weight-bolder text-dark">{formatAmount(this.state.transferData.vendorPayoutPending + this.state.transferData.azuroPayoutPending)}</span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span className="text-muted font-weight-bold">Received payment amount:</span>
                        <span className="font-weight-bolder text-success">{formatAmount(this.state.transferData.amount)}</span>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  {/* 3. Transfer to Vendor */}
                  <div className="card shadow-sm border-0 rounded-lg h-100">
                    <div className="card-header bg-white border-bottom-0 pb-0 pt-3">
                      <h6 className="font-weight-bolder text-dark">3. Transfer to Vendor (Vendor Payables)</h6>
                    </div>
                    <div className="card-body pt-2 pb-3">

                      {this.state.transferData.vendorPayoutPending <= 0 ? (
                        <div className="ml-4 pl-2 mt-2">
                          <Badge variant="success" className="p-2 mb-2"><i className="fa fa-check mr-2 text-white"></i>Settled (Vendor)</Badge>
                          <div className="text-muted small">The complete vendor payable amount has been settled. No further transfer is required.</div>
                        </div>
                      ) : (
                        <React.Fragment>
                          <Form.Check
                            type="checkbox"
                            id="vendor-transfer-check"
                            checked={this.state.transferVendorChecked}
                            onChange={(e) => this.setState({ transferVendorChecked: e.target.checked })}
                            label={<span className="font-weight-bolder text-dark ml-1 mt-1">Transfer Partial/Net Payable to {this.state.transferData.costEstimate?.vendorName || 'Vendor'}</span>}
                            className="mb-1"
                            style={{ transform: 'scale(1.1)' }}
                          />
                          <div className="text-muted small ml-4 pl-2 mb-3">Select to activate vendor payout settlement.</div>

                          {this.state.transferVendorChecked && (
                            <div className="ml-4 pl-2">
                              <Form.Group>
                                <div className="d-flex justify-content-between mb-2 pb-2 border-bottom">
                                  <span className="text-muted small">Total Payable: <strong className="text-dark">{formatAmount(this.state.transferData.vendorShare)}</strong></span>
                                  <span className="text-muted small">Total Paid: <strong className="text-dark">{formatAmount(this.state.transferData.vendorPayoutDone)}</strong></span>
                                  <span className="text-primary small font-weight-bold">Remaining Payable: <strong className="text-dark">{formatAmount(this.state.transferData.vendorPayoutPending)}</strong></span>
                                </div>
                                <Form.Label className="small font-weight-bold text-dark">Vendor Settlement Amount (₹)</Form.Label>
                                <Form.Control
                                  type="text"
                                  inputMode="decimal"
                                  value={this.state.vendorTransferAmount}
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    // Max 5 digits before decimal and max 2 digits after decimal
                                    if (/^\d{0,5}(\.\d{0,2})?$/.test(value)) {
                                      this.setState({
                                        vendorTransferAmount: value,
                                      });
                                    }
                                  }}
                                  className="font-weight-bold text-dark"
                                  style={{
                                    backgroundColor: '#fff',
                                    border: '1px solid #ced4da',
                                  }}
                                />
                                <Form.Text className="text-muted small mt-2">
                                  Enter the amount to transfer. Max Transfer Allowed: {formatAmount(this.state.maxVendorTransfer)} (Based on available customer balance of {formatAmount(this.state.availableCustomerBalance)})
                                </Form.Text>
                              </Form.Group>

                              {this.state.transferData.costEstimate?.gstType === 'GST_REG_VENDOR' && (!this.state.transferData.invoices || this.state.transferData.invoices.length === 0) && (
                                <div className="p-3 mt-3 rounded" style={{ backgroundColor: '#fff8e1', border: '1px solid #ffeeba', color: '#856404' }}>
                                  <i className="flaticon-warning text-warning mr-2"></i>
                                  <strong>Note:</strong> Vendor Full Payment is Not allowed without uploading invoice for GST registered Vendors.
                                </div>
                              )}
                            </div>
                          )}
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  {/* 4. Transfer to Azuro */}
                  <div className="card shadow-sm border-0 rounded-lg h-100">
                    <div className="card-header bg-white border-bottom-0 pb-0 pt-3">
                      <h6 className="font-weight-bolder" style={{ color: '#5c45e5' }}>4. Transfer to Azuro (Azuro Payables / Platform Margin)</h6>
                    </div>
                    <div className="card-body pt-2 pb-3">
                      {this.state.transferData.azuroPayoutPending <= 0 ? (
                        <div className="ml-4 pl-2 mt-2">
                          <Badge variant="success" className="p-2 mb-2"><i className="fa fa-check mr-2 text-white"></i>Settled (Azuro)</Badge>
                          <div className="text-muted small">The complete Azuro payable amount has been settled. No further transfer is required.</div>
                        </div>
                      ) : !this.state.isCompletePaymentReceived ? (
                        <div className="ml-4 pl-2 p-3 rounded" style={{ backgroundColor: '#fdf3f4', border: '1px solid #f8d7da', color: '#721c24' }}>
                          <i className="flaticon-warning mr-2"></i>
                          <strong>Advance Payment Rule:</strong> Azuro transfer is locked. Customer has only made an advance payment and complete payment has not been received.
                        </div>
                      ) : (
                        <React.Fragment>
                          <Form.Check
                            type="checkbox"
                            id="azuro-transfer-check"
                            checked={this.state.transferAzuroChecked}
                            onChange={(e) => this.setState({ transferAzuroChecked: e.target.checked })}
                            label={<span className="font-weight-bolder text-dark ml-1 mt-1">Transfer Azuro Margin & GST to Azuro Account</span>}
                            className="mb-1"
                            style={{ transform: 'scale(1.1)' }}
                          />
                          <div className="text-muted small ml-4 pl-2 mb-3">Select to activate platform margin sweep transfer to Azuro Corporate account.</div>

                          {this.state.transferAzuroChecked && (
                            <div className="ml-4 pl-2 pb-2">
                              <Form.Group>
                                <div className="d-flex justify-content-between mb-2 pb-2 border-bottom">
                                  <span className="text-muted small">Total Payable: <strong className="text-dark">{formatAmount(this.state.transferData.azuroShare)}</strong></span>
                                  <span className="text-muted small">Total Paid: <strong className="text-dark">{formatAmount(this.state.transferData.azuroPayoutDone)}</strong></span>
                                  <span className="text-primary small font-weight-bold">Remaining Payable: <strong className="text-dark">{formatAmount(this.state.transferData.azuroPayoutPending)}</strong></span>
                                </div>
                                <Form.Label className="small font-weight-bold text-dark">Azuro Settlement Amount (₹)</Form.Label>
                                <Form.Control
                                  type="text"
                                  inputMode="decimal"
                                  value={this.state.azuroTransferAmount}
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    // Max 5 digits before decimal and max 2 digits after decimal
                                    if (/^\d{0,5}(\.\d{0,2})?$/.test(value)) {
                                      this.setState({
                                        azuroTransferAmount: value,
                                      });
                                    }
                                  }}
                                  className="font-weight-bold text-dark"
                                  style={{
                                    backgroundColor: '#fff',
                                    border: '1px solid #ced4da',
                                  }}
                                />
                                <Form.Text className="text-muted small mt-2">
                                  Enter the amount to transfer. Max Transfer Allowed: {formatAmount(this.state.maxAzuroTransfer)} (Based on available customer balance of {formatAmount(this.state.availableCustomerBalance)})
                                </Form.Text>
                              </Form.Group>
                            </div>
                          )}
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="mb-0">
                <Col md={12}>
                  {/* 5. Select Transfer Mode */}
                  <div className="card shadow-sm border-0 rounded-lg p-3 d-flex align-items-center justify-content-between">
                    <div>
                      <h6 className="font-weight-bolder text-dark mb-1">5. Select Transfer Mode</h6>
                      <span className="small text-muted">Use NEFT when the selected bank account does not support IMPS transfers.</span>
                    </div>
                    <Form.Control as="select" value={this.state.transferMode} onChange={(e) => this.setState({ transferMode: e.target.value })} style={{ width: '250px' }} className="font-weight-bold border-primary text-primary">
                      <option value="IMPS">IMPS</option>
                      <option value="NEFT">NEFT</option>
                      <option value="RTGS">RTGS</option>
                    </Form.Control>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="bg-white d-flex justify-content-between align-items-center py-3 border-top">
              <div className="font-weight-normal text-muted">
                Final amount to transfer: <strong className="text-dark font-weight-bolder ml-1" style={{ fontSize: '1.1rem' }}>{formatAmount((this.state.transferVendorChecked ? Number(this.state.vendorTransferAmount || 0) : 0) + (this.state.transferAzuroChecked ? Number(this.state.azuroTransferAmount || 0) : 0))}</strong>
              </div>
              <div>
                <Button variant="light" className="mr-2 font-weight-bold bg-white text-dark border shadow-sm px-4 py-2 rounded-pill" onClick={() => this.setState({ showInitiateTransferModal: false })}>
                  Cancel
                </Button>
                <Button variant="primary" className="font-weight-bold shadow-sm px-4 py-2 rounded-pill" style={{ backgroundColor: '#4432c9' }} disabled={this.state.isInitiatingTransfer || (!this.state.transferVendorChecked && !this.state.transferAzuroChecked)} onClick={this.submitTransfer}>
                  {this.state.isInitiatingTransfer ? 'Processing...' : 'Initiate Transfer'}
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}

        {/* Custom Validation Error Modal */}
        <Modal show={!!this.state.validationError} onHide={() => this.setState({ validationError: null })} centered size="sm">
          <div className="bg-white rounded p-4 text-center border-0 shadow">
            <div className="mb-3">
              <i className="flaticon-warning text-danger" style={{ fontSize: '3rem' }}></i>
            </div>
            <h5 className="font-weight-bolder text-dark mb-3">Notice</h5>
            <p className="text-muted mb-4">{this.state.validationError}</p>
            <Button variant="danger" className="font-weight-bold px-4 rounded-pill" onClick={() => this.setState({ validationError: null })}>
              Close
            </Button>
          </div>
        </Modal>

        {/* Custom Success Modal */}
        <Modal show={!!this.state.successMessage} onHide={() => this.setState({ successMessage: null })} centered size="sm">
          <div className="bg-white rounded p-4 text-center border-0 shadow">
            <div className="mb-3">
              <i className="fa fa-check-circle text-success" style={{ fontSize: '3rem' }}></i>
            </div>
            <h5 className="font-weight-bolder text-dark mb-3">Success</h5>
            <p className="text-muted mb-4">{this.state.successMessage}</p>
            <Button variant="success" className="font-weight-bold px-4 rounded-pill" onClick={() => this.setState({ successMessage: null })}>
              Done
            </Button>
          </div>
        </Modal>

      </Container>
    );
  }
}

const mapStateToProps = state => ({
  userDetails: state.auth && state.auth.user
});

export default connect(mapStateToProps, null)(VendorSettlements);
